<template>
  <div class="maximize">
    <b-container
      :class="{
        videoContainer: programmingMode,
        'form-row-container': !programmingMode,
      }"
    >
      <b-row id="videoRow">
        <b-col
          id="publisher"
          :class="{ center: true, publisherProgramming: programmingMode }"
          cols="4"
        >
          <div v-if="videoNotPublished" class="text-center">
            <b-spinner type="grow" class="btn-bsc"></b-spinner>
            <p class="videoConnectText text-muted">
              {{ waitingForVideoText }}
            </p>
          </div>
        </b-col>

        <b-col v-if="!videoConnectionAccepted" class="center" cols="8">
          <div>
            <b-button
              type="submit"
              size="lg"
              class="btn-bsc"
              @click="connectToVideoChannel"
              >Connect</b-button
            >
            <p class="videoConnectText text-muted">
              You and your patient have successfully joined the session! Press
              connect to begin video call and get their device information.
            </p>
          </div>
        </b-col>

        <b-col
          v-if="videoConnectionAccepted && !programmingMode"
          class="center"
          cols="4"
        >
          <div class="text-center">
            <p>Device: {{ device }}</p>
            <p>Serial Number: {{ serialNumber }}</p>
            <b-button
              size="lg"
              v-if="!patientIsNotConnected"
              type="submit"
              class="btn-bsc"
              @click="changeToProgrammingMode"
            >
              Connect
            </b-button>
          </div>
        </b-col>

        <b-col
          id="subscriber"
          v-if="videoConnectionAccepted"
          :class="{ center: true, subscriberProgramming: programmingMode }"
          cols="4"
        >
          <div v-if="patientIsNotConnected" class="text-center">
            <b-spinner
              v-if="patientWasNeverConnected"
              type="grow"
              class="btn-bsc"
            ></b-spinner>
            <p class="videoConnectText text-muted">
              {{ waitingForVideoText }}
            </p>
          </div>
        </b-col>
      </b-row>

      <b-row v-if="!programmingMode" id="videoControlsRow">
        <b-col cols="4">
          <b-button-group id="toggleVideo">
            <b-button
              squared
              v-if="!videoNotPublished"
              type="submit"
              class="btn-bsc"
              @click="toggleVideo"
            >
              <b-icon :icon="videoIcon" variant="light"></b-icon>
            </b-button>

            <b-button
              squared
              v-if="!videoNotPublished"
              type="submit"
              class="btn-bsc"
              @click="toggleAudio"
            >
              <b-icon :icon="audioIcon" variant="light"></b-icon>
            </b-button>
          </b-button-group>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import OT from "@opentok/client";
import store from "@/store/index.js";

export default {
  name: "Video",
  data() {
    return {
      videoNotPublished: true,
      patientIsNotConnected: true,
      patientWasNeverConnected: true,
      videoConnectionAccepted: false,
      programmingMode: false,
      videoIcon: "camera-video",
      audioIcon: "mic",
      device: "-",
      serialNumber: "-",
      session: null,
      publisher: null,
      waitingForVideoText: "Connecting to Camera",
    };
  },
  created() {
    this.establishDataChannel();
    this.initializeVideoSession();
  },
  methods: {
    changeToProgrammingMode() {
      this.$emit("changeToProgrammingMode");
      this.programmingMode = true;
    },

    establishDataChannel() {
      const self = this;
      store.getters["ably/ablyChannel"].subscribe("patient-info", (msg) => {
        self.device = msg.data.device;
        self.serialNumber = msg.data.serial;
      });
    },

    initializeVideoSession() {
      this.session = store.getters["avConnection/videoSession"];
      const self = this;

      this.session.on("streamCreated", (event) => {
        self.patientIsNotConnected = false;
        self.patientWasNeverConnected = false;
        function subscribe() {
          if (self.videoConnectionAccepted) {
            self.session.subscribe(
              event.stream,
              "subscriber",
              {
                insertMode: "append",
                width: "100%",
                height: "100%",
              },
              (error) => (error ? alert(error.message) : null)
            );
          } else {
            setTimeout(subscribe, 300);
          }
        }
        subscribe();
      });

      this.session.on("streamDestroyed", () => {
        self.waitingForVideoText = "Patient has disconnected";
        self.patientIsNotConnected = true;
      });

      this.session.connect(
        store.getters["avConnection/videoToken"],
        (error) => {
          if (error) {
            self.waitingForVideoText =
              "Failed to connect to Video Session - " + error.message;
          } else {
            var publisherProperties = {
              insertMode: "append",
              width: "100%",
              height: "100%",
            };
            self.publisher = OT.initPublisher("publisher", publisherProperties);
            self.waitingForVideoText =
              "Waiting for patient to acknowledge remote programming";
            self.videoNotPublished = false;
          }
        }
      );
    },

    connectToVideoChannel() {
      this.videoConnectionAccepted = true;
      this.session.publish(this.publisher);
    },

    toggleVideo() {
      if (this.videoIcon === "camera-video") {
        this.publisher.publishVideo(false);
        this.videoIcon = "camera-video-off";
      } else {
        this.publisher.publishVideo(true);
        this.videoIcon = "camera-video";
      }
    },

    toggleAudio() {
      if (this.audioIcon === "mic") {
        this.publisher.publishAudio(false);
        this.audioIcon = "mic-mute";
      } else {
        this.publisher.publishAudio(true);
        this.audioIcon = "mic";
      }
    },

    // turnStimulationOn() {
    //   const command = new Uint8Array([
    //     0x28, 0x10, 0x23, 0x00, 0x4a, 0x00, 0x00, 0x00, 0x01, 0x01, 0x0f, 0x0f,
    //     0x2c, 0x01, 0x70, 0xa9,
    //   ]);
    //   store.state.ablyChannel.subscribe("telemetry-response", (msg) => {
    //     console.log(msg);
    //     console.log(msg.data);
    //   });
    //   store.state.ablyChannel.publish("telemetry-request", {
    //     command: Array.from(command),
    //   });
    // },

    // turnStimulationOff() {
    //   const command = new Uint8Array([
    //     0x28, 0x10, 0x23, 0x00, 0x4a, 0x00, 0x00, 0x00, 0x01, 0x01, 0x0f, 0x0f,
    //     0x26, 0x02, 0xd8, 0x76,
    //   ]);
    //   store.state.ablyChannel.subscribe("telemetry-response", (msg) => {
    //     console.log(msg);
    //     console.log(msg.data);
    //   });
    //   store.state.ablyChannel.publish("telemetry-request", {
    //     command: Array.from(command),
    //   });
    // },

    // increaseAmplitude() {
    //   const command = new Uint8Array([
    //     0x28, 0x1b, 0x19, 0x00, 0x5e, 0x00, 0x00, 0x00, 0x00, 0x04, 0xa8, 0x00,
    //     0x00, 0x00, 0xb0, 0x00, 0x00, 0x00, 0x0e, 0x01, 0x00, 0x00, 0x10, 0x01,
    //     0x00, 0x00, 0x26, 0xa5,
    //   ]);
    //   store.state.ablyChannel.subscribe("telemetry-response", (msg) => {
    //     console.log(msg);
    //     console.log(msg.data);
    //   });
    //   store.state.ablyChannel.publish("telemetry-request", {
    //     command: command,
    //   });
    // },

    // decreaseAmplitude() {
    //   const command = new Uint8Array([
    //     0x28, 0x0b, 0x2c, 0x01, 0x04, 0x00, 0x8e, 0x87, 0x01, 0xe2, 0x1a,
    //   ]);
    //   store.state.ablyChannel.subscribe("telemetry-response", (msg) => {
    //     console.log(msg);
    //     console.log(msg.data);
    //   });
    //   store.state.ablyChannel.publish("telemetry-request", {
    //     command: command,
    //   });
    // },
  },
};
</script>
